// import SelectComp from 'components/form-elements/SelectComp'
import Icons from 'assets/icons'
import React from 'react'
import auth from 'utils/Auth'


const NavbarSelect = () => {

    // const options = [
    //     { value: 'Lara1 Cadde Tavuk Düny...', label: 'Lara1 Cadde Tavuk Düny...' },
    //     { value: 'Lara2 Cadde Tavuk Düny...', label: 'Lara2 Cadde Tavuk Düny...' },
    //     { value: 'Lara3 Cadde Tavuk Düny...', label: 'Lara3 Cadde Tavuk Düny...' }
    //   ]
  
  return (
    // <div className='navbar-select'>
    <div className='navbar-text'>
         {/* <SelectComp options={options}/> */}
         <Icons.location color='#B40000' size={22}/>
         <span>{auth?.getUserChoises()?.restaurantName}</span>
    </div>
  )
}

export default NavbarSelect

